module.exports = __webpack_public_path__ + "img/HC1024-76.1786ab5e.jpg";